<template>
	<header id="navbar">
		<b-navbar toggleable="lg" type="dark" fixed="top" variant="dark">
			<b-navbar-brand to="/">Character.Gallery</b-navbar-brand>

			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

			<b-collapse id="nav-collapse" is-nav>
				<b-navbar-nav class="flex-md-row d-inline-flex">
					<b-nav-item :to="{name:'play'}" link-classes="px-2">Play</b-nav-item>
					<b-nav-item :to="{name:'basics'}" link-classes="px-2">Basics</b-nav-item>
					<b-nav-item :to="{name:'planning'}" link-classes="px-2">Planning</b-nav-item>
					<b-nav-item :to="{name:'skills'}" link-classes="px-2">Skills</b-nav-item>
					<b-nav-item :to="{name:'combat'}" link-classes="px-2">Combat</b-nav-item>
					<b-nav-item :to="{name:'equipment'}" link-classes="px-2">Equipment</b-nav-item>
					<b-nav-item :to="{name:'journal'}" link-classes="px-2">Journal</b-nav-item>
					<b-nav-item :to="{name:'society'}" link-classes="px-2">Society</b-nav-item>
				</b-navbar-nav>

				<b-navbar-nav class="ml-auto flex-md-row d-inline-flex justify-content-end float-right">
					<b-nav-item-dropdown right text="Character" ref="character-dropdown" toggle-class="btn btn-outline-light custom-navbar-menu-button mr-md-1 px-2">
						<b-dropdown-item class="has-icon" @click="newCharacter()">
							<font-awesome-icon icon="user"></font-awesome-icon>New Character
						</b-dropdown-item>
						<b-dropdown-divider></b-dropdown-divider>
						<li role="presentation" class="has-icon">
							<file-upload @upload="loadCharacter($event)"></file-upload>
						</li>
						<b-dropdown-item class="has-icon" v-if="isLoggedIn" @click="showAccountCharacters">
							<font-awesome-icon icon="cloud-download-alt"></font-awesome-icon>Load from Account
						</b-dropdown-item>
						<b-dropdown-item class="has-icon">
							<font-awesome-icon :icon="['fab','dropbox']"></font-awesome-icon>Load from Dropbox
						</b-dropdown-item>
						<b-dropdown-divider></b-dropdown-divider>
						<b-dropdown-item class="has-icon">
							<font-awesome-icon icon="download"></font-awesome-icon>Save to File
						</b-dropdown-item>
						<b-dropdown-item class="has-icon" v-if="isLoggedIn">
							<font-awesome-icon icon="cloud-upload-alt"></font-awesome-icon>Save to Account
						</b-dropdown-item>
						<b-dropdown-item class="has-icon">
							<font-awesome-icon :icon="['fab','dropbox']"></font-awesome-icon>Save to Dropbox
						</b-dropdown-item>
						<b-dropdown-divider></b-dropdown-divider>
						<b-dropdown-item class="has-icon" v-if="isLoggedIn && false">
							<font-awesome-icon icon="share"></font-awesome-icon>Share
						</b-dropdown-item>
						<b-dropdown-item class="has-icon" @click="printCharacter">
							<font-awesome-icon icon="print"></font-awesome-icon>Print
						</b-dropdown-item>
					</b-nav-item-dropdown>

					<b-nav-item-dropdown right text="Misc" toggle-class="btn btn-outline-light custom-navbar-menu-button mr-md-1 px-2">
						<b-dropdown-item class="has-icon">
							<font-awesome-icon icon="cogs"></font-awesome-icon>Options
						</b-dropdown-item>
						<b-dropdown-divider></b-dropdown-divider>
						<b-dropdown-item class="has-icon" href="https://blog.character.gallery" target="_outside">
							<font-awesome-icon icon="newspaper"></font-awesome-icon>Blog
						</b-dropdown-item>
					</b-nav-item-dropdown>

					<b-nav-item v-if="isLoggedIn" @click="logout" link-classes="btn btn-outline-light custom-navbar-menu-button px-2">Logout</b-nav-item>
					<b-nav-item v-else @click="login" link-classes="btn btn-outline-light custom-navbar-menu-button px-2">Login</b-nav-item>
				</b-navbar-nav>

			</b-collapse>
		</b-navbar>
	</header>
</template>

<script>
import FileUpload from '@/components/FileUpload.vue'

import Printd from 'printd'
const d = new Printd()
var printCSS = `
.border {
	border: 1px solid grey;
}
.box-info {
	width: 100%;
}
.print-page {
	page-break-after: always;
}
.print-row {
	page-break-inside: avoid;
}
.table-cell-blank {
	width: 4em;
}
.avoid-page-break-after {
	break-after: avoid-page;
}
div.pre {
	white-space: pre-line;
}
.col-light {
	padding-left: 5px;
	padding-right: 5px;
}
#avatar {
	max-width:150px;
}
`

export default {
	components: {
		'FileUpload': FileUpload,
	},
	computed: {
		isLoggedIn: function(){
			return this.$store.getters['account/isLoggedIn']
		}
	},
	methods: {
		newCharacter: function() {
			this.$store.commit('startOver')
		},
		loadCharacter: function(event) {
			this.$store.dispatch('loadCharacter',event)
			this.$refs['character-dropdown'].hide(true)
		},
		printCharacter: function() {
			d.print( document.getElementById('print'), [
				printCSS,
				'/css/bootstrap.min.css',
			])
		},
		login: function() {
			this.$store.dispatch('modals/showLogin')
		},
		logout: function() {
			this.$store.dispatch('account/logout')
		},
		showAccountCharacters: function() {
			this.$store.dispatch('characters/show')
		}
	},
}
</script>

<style>
.has-icon svg {
	margin-right: 5px;
}
.custom-navbar-menu-button {
	color: #f8f9fa!important;
}
.custom-navbar-menu-button:hover {
	color: #212529!important;
}
.custom-navbar-menu-button:not(:disabled):not(.disabled).active, 
.custom-navbar-menu-button:not(:disabled):not(.disabled):active, 
.show>.custom-navbar-menu-button.dropdown-toggle {
    color: #212529!important;
}
.navbar-collapse.collapsing {
	overflow-y:hidden!important;
}
</style>